import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import { AppColors } from "../../../../util/AppColors";
// import CustomButton from '../../../../components/CustomButton/CustomButton';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomTable from "../../../../components/CustomTable";
import CustomTextField from "../../../../components/CustomTextField";
import TopBar from "../../../../components/TopBar/TopBar";
import {
  addBreed,
  deleteBreed,
  getAllBreeds,
  updateBreed,
} from "../../../../redux/reducers/breedSlice";
import { getSpeciesList } from "../../../../redux/reducers/speciesSlice";

function Breeds({ speciesId, onBack }) {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({
    breedName: "",
    speciesId: "",
  });
  const [delModVisible, setDelModVisible] = useState(false);
  const [breedIdToDelete, setBreedIdToDelete] = useState(null);
  const [selectedSpeciesId, setSelectedSpeciesId] = useState("");

  const speciesList = useSelector((state) => state.species.list);
  const { breeds, loading } = useSelector((state) => state.breed);

  // useEffect(() => {
  //   if (speciesId) {
  //     dispatch(getSpeciesList());
  //     dispatch(getAllBreeds(speciesId));
  //   }
  // }, [dispatch, speciesId]);
  useEffect(() => {
    dispatch(getSpeciesList()); // ✅ always fetch species list for mapping ID → Name

    if (speciesId) {
      dispatch(getAllBreeds(speciesId));
      setSelectedSpeciesId(speciesId); // keep your local state updated too
    }
  }, [dispatch, speciesId]);

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
    setEditIndex(null);
    setForm({ breedName: "", speciesId: speciesId });
  };

  const handleEdit = (index) => {
    const breed = breeds[index];
    setForm({ breedName: breed.breedName, speciesId: speciesId });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  const handleSubmit = async () => {
    if (!form.speciesId || !form.breedName) {
      alert("Species and Breed Name are required.");
      return;
    }

    try {
      if (editIndex !== null) {
        const breed = breeds[editIndex];
        await dispatch(
          updateBreed({
            breedId: breed.breedId,
            breedName: form.breedName,
            speciesId: form.speciesId,
          }),
        ).unwrap();
      } else {
        await dispatch(addBreed(form)).unwrap();
      }

      // dispatch(getAllBreeds());
      dispatch(getAllBreeds(selectedSpeciesId));
      handleCloseDrawer();
    } catch (err) {
      alert("Something went wrong.");
    }
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setEditIndex(null);
    setForm({ breedName: "", speciesId: "" });
  };

  const handleDelete = async (breedId) => {
    try {
      await dispatch(deleteBreed(breedId)).unwrap();
      // dispatch(getAllBreeds());
      dispatch(getAllBreeds(selectedSpeciesId));
    } catch (error) {
      alert("Failed to delete breed.");
    }
  };
  const handleDelModOpen = (breedId) => {
    setBreedIdToDelete(breedId);
    setDelModVisible(true);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setBreedIdToDelete(null);
  };

  const handleDelConfirm = async () => {
    try {
      await dispatch(deleteBreed(breedIdToDelete)).unwrap();
      // dispatch(getAllBreeds());
      dispatch(getAllBreeds(selectedSpeciesId));
    } catch {
      alert("Failed to delete breed.");
    } finally {
      handleDelModClose();
    }
  };

  const getSpeciesNameById = (id) => {
    const found = speciesList.find((s) => s.speciesId === id);
    return found?.speciesName || "Unknown";
  };

  const filteredRows = breeds.filter((row) =>
    row.breedName.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <Box>
      {/* Header */}
      <TopBar sx={{ py: 1, minHeight: "unset" }}>
        <Container maxWidth="xl">
          <div className="flex-row-ali-cen">
            <div className="flex-row-ali-cen cursor" onClick={onBack}>
              <ArrowBackIcon
                sx={{ color: AppColors.appPrimary, width: 20, height: 20 }}
              />
              <Typography className="fs16 txt-semi-bold blue-color ml5">
                Back
              </Typography>
            </div>
            <div className="top-row-cen-con w100Per">
              <div className="w30Per">
                <CustomTextField
                  placeholder="Search"
                  name="name"
                  fullWidth
                  handleChange={(e) => setSearch(e.target.value)}
                  value={search}
                  backgroundColor={AppColors.lightBlue2}
                />
              </div>

              <div className="ml20">
                <CustomButton text="Create" onClick={handleOpenDrawer} />
              </div>
            </div>
          </div>
          <Typography className="font-medium fs12 gray28 mt5">
            Total Breeds: {filteredRows?.length}
          </Typography>
        </Container>
      </TopBar>

      {/* Table */}
      <CustomTable
        grey
        columns={[
          "sNo",
          "breedName",
          "speciesName",
          "createdBy",
          "createdDate",
          "actions",
        ]}
        datas={filteredRows.map((row, index) => ({
          sNo: index + 1,
          breedName: row?.breedName,
          speciesName:
            speciesList?.find((s) => s?.speciesId === speciesId)?.speciesName ||
            "Unknown",
          createdBy: row?.userName ?? "-",
          createdDate: new Date(row?.createdDate).toLocaleDateString(),
          actions: (
            <div>
              <IconButton
                color="primary"
                size="small"
                onClick={() => handleEdit(index)}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                color="error"
                size="small"
                onClick={() => handleDelModOpen(row?.breedId)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        }))}
        maxHeight="68vh"
      />

      {/* Drawer */}
      <Drawer anchor="right" open={openDrawer} onClose={handleCloseDrawer}>
        <Box p={3} width={300} sx={{ maxHeight: "100vh", overflowY: "auto" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Breed" : "Create Breed"}
            </Typography>
            <IconButton onClick={handleCloseDrawer} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          <TextField
            select
            fullWidth
            label="Species"
            value={form.speciesId}
            onChange={(e) => setForm({ ...form, speciesId: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          >
            {speciesList.map((item) => (
              <MenuItem key={item.speciesId} value={item.speciesId}>
                {item.speciesName}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            fullWidth
            label="Breed Name"
            value={form.breedName}
            onChange={(e) => setForm({ ...form, breedName: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleSubmit}
            disabled={!form.speciesId || !form.breedName}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?{" "}
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default Breeds;
